import { Logger } from '../../../../common/utils/logger';
import { getSetCookieOverride } from '../set-cookie-override';

// Hijack the document.cookie setter logic so we can track cookie and usage info if we've opted into cookies management
// This will generate a passthrough that will call the original document.cookie setter logic after we've logged analytics
export const createDocumentCookiePassthroughSync = (): void => {
	const documentCookieProperty = Object.getOwnPropertyDescriptor(Document.prototype, 'cookie');
	const originalSetter = documentCookieProperty?.set;
	const originalGetter = documentCookieProperty?.get;

	if (!originalSetter || !originalGetter) {
		Logger.warn('No document.cookie capabilities found');
		return;
	}

	// Override document.cookie setter
	Object.defineProperty(document, 'cookie', {
		get: originalGetter,
		set: getSetCookieOverride(originalSetter),
		configurable: true,
	});
};

/**
 * @private
 * @deprecated Async wrapper retained only for the `platform_bsc_sync_initialize_controls` OFF path.
 * Prefer {@link createDocumentCookiePassthroughSync}, which installs the override on the calling
 * tick. Removed once the gate reaches 100% — see COOK-608.
 */
export const createDocumentCookiePassthrough = async (): Promise<void> =>
	createDocumentCookiePassthroughSync();
